import React from 'react'
import classnames from 'classnames'
import Toggle from '../../../../shared/Toggle'
import {ReactComponent as LayersIcon} from '../../../../assets/icons/all-layers.svg'
import {VIEW_MODES} from '../../constants/editorConfig'

const SilhouetteIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <rect x="1" y="1" width="16" height="16" rx="3" ry="3" fill="currentColor" />
    </svg>
)

const VIEW_OPTIONS = [
    {
        value: VIEW_MODES.SILHOUETTE,
        label: 'Silhouette View',
        icon: <SilhouetteIcon />,
    },
    {
        value: VIEW_MODES.OVERLAY,
        label: 'Overlay View',
        icon: <LayersIcon />,
    },
]

/**
 * View toggle: Silhouette View | Overlay View. Built on shared Toggle.
 *
 * @param {string} value - VIEW_MODES.SILHOUETTE | VIEW_MODES.OVERLAY
 * @param {function(string): void} onChange
 * @param {string} [className]
 */
const ViewToggle = ({value, onChange, className}) => (
    <Toggle
        className={classnames('ViewToggle', className)}
        name="View mode"
        options={VIEW_OPTIONS}
        value={value}
        onChange={onChange}
    />
)

export default ViewToggle
